<template>
  <Section title="skills">
    <div class="skills-wrap">
      <!-- technical skills -->
      <div class="skills__container">
        <!-- front end -->
        <Skill
          title="Front End"
          icon="laptop-code"
          :skills="['HTML5, CSS3, Sass','TypeScript, JavaScript','jQuery, PWA, Redux','Angular8, React, Vue']"
        />

        <!-- back end -->
        <Skill
          title="Back End"
          icon="share-alt"
          :skills="['Node','Express, Koa','GraphQL','Python']"
        />

        <!-- database -->
        <Skill
          title="Database"
          icon="database"
          :skills="['PostgreSQL','mySQL','MongoDB','Sequelize, Firebase']"
        />

        <!-- deployment -->
        <Skill title="Deployment" icon="cloud" :skills="['Heroku','Firebase','AWS']" />

        <!-- version control -->
        <Skill title="Version Control" icon="code-branch" :skills="['BitBucket','Git','GitHub']" />

        <!-- software and tools -->
        <Skill
          title="Software & Tools"
          icon="tools"
          :skills="['Visual Studio Code','Photoshop & Illustrator','AutoCAD, ZBrush']"
        />
      </div>
    </div>
    <Timeline />
  </Section>
</template>

<script>
import Skill from "@/components/globals/Skill";
import Timeline from "@/components/home/Timeline";

export default {
  name: "SkillSection",
  components: {
    Skill,
    Timeline
  }
};
</script>